import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["growth-architecture"]!.fr;

export const Route = createFileRoute("/services/growth-architecture")({
  head: () =>
    pageHead({
      path: "/services/growth-architecture",
      title: c.title,
      description: c.description,
      crumbs: [["Services", "/services"], ["Growth Architecture", "/services/growth-architecture"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="growth-architecture" />,
});
